import { Deserializable } from '../_common/deserializable';

export class Keyword implements Deserializable{
    id: number;
    source: number;
    sourceView: string;
    shortCode: string;
    keyword: string;
    operator: string;
    type: number;
    typeView: string;
    category: number;
    categoryView: string;
    interval: number;
    intervalView: string;
    schedules: string;
    price: number;
    currency: string;
    country: string;
    managerId: number;
    timezone: string;
    premiumService: string;
    moNotifyUrl: string;
    dnNotifyUrl: string;
    cnvUrl: string;
    moMin: number;
    dnMin: number;
    cnvMin: number;
    moCap: number;
    dnCap: number;
    cnvCap: number;
    createdAt: string;
    managerName: string;
    managerRole: string;
    share: string;
    status: number;
    msg: string;
    spiderAccountId: number;
    spiderAccountName: string;
    moPostBackRate:  number;
    dnPostBackRate: number;
    cnvPostBackRate: number;
    affiliateEnabled: boolean;
    affiliateClickEnabled: boolean;
    reminderPeriod: number;
    reminderPeriodView: string;
    revenueShareRatio: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
